import seoImage from '../assets/search-engine-optimization-sml.webp';
import webImage from '../assets/laptop-computer-icons-sm.webp';
import socialImage from '../assets/social-media-marketing-sm.webp';
import roundTableImg from '../assets/roundtable.webp';
import minimalDesignImg from '../assets/minimal-logo-design-item-sm.webp';
import diffCulturesImg from '../assets/different_cultures-sm.webp';
import devsOnCouchImg from '../assets/developers_on_a_couch.webp';
import mobileAppImg from '../assets/mobileAppImage.webp';

export const HomePageImages = {
    seoImage,
    webImage,
    socialImage,
    roundTableImg,
    minimalDesignImg,
    diffCulturesImg,
    devsOnCouchImg,
    mobileAppImg
}